import { ChannelContext } from '@/contexts/channel.context';
import { useContext } from 'react';
import { useEffect } from 'react';
import { isLiveNowContent } from 'utils';
import ChannelGridRow from '../ChannelGridRow/ChannelGridRow';
import { isMobile } from 'react-device-detect';

type Props = {
  channels: any;
};

const ChannelsGrid: React.FC<Props> = ({ channels }: Props) => {
  const {
    mainPlaylist,
    playlists,
    setPlaylists,
    setMainPlaylist,
    setNowPlaying,
  } = useContext(ChannelContext);

  useEffect(() => {
    if (!mainPlaylist) {
      setMainPlaylist(channels[0]);
    }
  }, [channels, setMainPlaylist, mainPlaylist]);

  useEffect(() => {
    if (mainPlaylist) {
      setPlaylists(
        channels.filter((channel) => channel._id !== mainPlaylist._id),
      );
      if (mainPlaylist.channel_type === 'live_channel') {
        const liveNowContent = mainPlaylist.contents.find((content) =>
          isLiveNowContent(content),
        );
        const nowPlayingContent = liveNowContent
          ? liveNowContent
          : mainPlaylist.contents[0];
        setNowPlaying(nowPlayingContent);
      }
    }
  }, [channels, mainPlaylist, setNowPlaying, setPlaylists]);

  return (
    <>
      {mainPlaylist && (
        <ChannelGridRow playlist={mainPlaylist} featured swipeEnabled={true} />
      )}
      <div className="py-4 bg-gradient-to-t from-black to-transparent max-h-64 overflow-y-scroll">
        {playlists.map((playlist) => (
          <ChannelGridRow
            key={playlist._id}
            playlist={playlist}
            swipeEnabled={isMobile}
          />
        ))}
      </div>
    </>
  );
};

export default ChannelsGrid;
